import { render, staticRenderFns } from "./PaymentRatesTab.vue?vue&type=template&id=31b48e10&scoped=true&"
import script from "./PaymentRatesTab.vue?vue&type=script&lang=js&"
export * from "./PaymentRatesTab.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRatesTab.vue?vue&type=style&index=0&id=31b48e10&lang=scss&scoped=true&"
import style1 from "./PaymentRatesTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b48e10",
  null
  
)

export default component.exports